import axios from "axios";
export const BACKEND_URL = "https://axis.optora.com/";
const axiosAxis = axios.create({
  baseURL: '/api/proxy/',
});

axiosAxis.interceptors.request.use((config) => {
  config.headers["Content-Type"] = "application/json";
  return config;
});

export default axiosAxis;
